import React, { useRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useTranslation } from "react-i18next";
import { themeConfig } from "config/ThemeConfig";
import "./VehicleQRCode.css";

/**
 * Hostname'e göre aktif theme'i döndürür
 */
function getActiveTheme() {
  const hostname = window.location.hostname;
  const themeKey = Object.keys(themeConfig).find((key) => hostname.includes(key)) || process.env.REACT_APP_DEFAULT_THEME;
  return themeConfig[themeKey] || themeConfig.servistesin;
}

/**
 * Araç plakası için QR kod yazdırma component'i
 * @param {Object} props
 * @param {string} props.plate - Araç plakası
 * @param {boolean} props.isOpen - Modal açık mı
 * @param {Function} props.onClose - Modal kapatma fonksiyonu
 */
const VehicleQRCode = ({ plate, isOpen, onClose }) => {
  const { t } = useTranslation();
  const printRef = useRef();
  const theme = getActiveTheme();

  if (!isOpen) return null;

  // QR içeriği sadece plaka - boşluksuz ve büyük harfli
  const qrContent = plate.replace(/\s+/g, "").toUpperCase();

  const handlePrint = () => {
    const printContent = printRef.current;
    const windowPrint = window.open("", "", "width=400,height=600");

    windowPrint.document.write(`
      <html>
        <head>
          <title>QR Kod - ${plate}</title>
          <style>
            * {
              box-sizing: border-box;
              margin: 0;
              padding: 0;
            }
            body {
              margin: 0;
              padding: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 100vh;
              height: 100vh;
              width: 100vw;
              font-family: Arial, sans-serif;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            }
            .qr-print-container {
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
              justify-content: center !important;
              text-align: center !important;
              padding: 30px;
              border: none;
              background: white;
            }
            .qr-theme-name {
              font-size: 20px;
              font-weight: 600;
              color: #333;
              margin-bottom: 20px;
              text-align: center !important;
            }
            .qr-code-wrapper {
              margin: 20px 0;
              display: flex !important;
              justify-content: center !important;
            }
            .qr-plate {
              font-size: 22px;
              font-weight: bold;
              margin-top: 15px;
              letter-spacing: 2px;
              color: #333;
              text-align: center !important;
            }
            @media print {
              body {
                padding: 0;
              }
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);

    windowPrint.document.close();
    windowPrint.focus();

    setTimeout(() => {
      windowPrint.print();
      windowPrint.close();
    }, 250);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="qr-modal-backdrop" onClick={handleBackdropClick}>
      <div className="qr-modal-content">
        <button className="qr-modal-close" onClick={onClose}>
          &times;
        </button>

        <div ref={printRef} className="qr-print-container">
          <div className="qr-theme-name">{theme.name}</div>

          <div className="qr-code-wrapper">
            <QRCodeSVG value={qrContent} size={280} level="H" includeMargin={true} />
          </div>

          <div className="qr-plate">{plate}</div>
        </div>

        <div className="qr-modal-actions">
          <button type="button" className="qr-print-button" onClick={handlePrint}>
            {t("print") || "Yazdır"}
          </button>
          <button type="button" className="qr-close-button" onClick={onClose}>
            {t("close") || "Kapat"}
          </button>
        </div>

        <div className="qr-print-hint">
          Yazdır tuşuna basıldığında açılacak ekranda ayarlar bölümünde yer alan "Üstbilgiler ve altbilgiler" (Header and Footer) seçeneğini kapatın. Aksi halde bastırılan dosyada yazdırma tarihi gibi ek bilgiler görünecektir.
        </div>
      </div>
    </div>
  );
};

export default VehicleQRCode;
